import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import {CoreService} from "../shared/services/core.service";

@Injectable({
  providedIn: 'root'
})
export class SecureSessionGuard implements CanActivate {

  constructor(private coreService: CoreService) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const secureSessionId = route.params.secureSessionId;

    // if the secure sessionId doesn't exist or is empty, return false
    const hasSession = !secureSessionId || secureSessionId !== "";

    this.coreService.setCanAccess(hasSession);

    return hasSession;
  }

}
